import "./text-callout.scss";

import cn from "clsx";
import { ReactNode } from "react";
import { Alignment, EditAttributes } from "design-system/types/types";
import { TeaseCarousel } from "design-system/components/blocks/tease-carousel/tease-carousel";
import { TeaseCarouselItem } from "design-system/components/blocks/tease-carousel/tease-carousel-item";

export interface TextCalloutItem {
  content: ReactNode;

  editAttributes?: {
    content?: EditAttributes;
  };
}

export interface TextCalloutProps {
  titleContent?: ReactNode;
  /** One or more `Carousel.Item`s */
  items?: Array<TextCalloutItem>;
  align?: Alignment;
  HeadingLevel?: "h2" | "h3";
  className?: string;

  editAttributes?: {
    titleContent?: EditAttributes;
  };
}

export function TextCallout({
  titleContent,
  items,
  align = "center",
  HeadingLevel = "h2",
  className,
  editAttributes,
}: TextCalloutProps) {
  if (!items || items.length === 0) {
    return null;
  }
  const wrapperClass = cn(
    `hbs-global-align-${align}`,
    "hbs-text-callout",
    className,
  );

  const headerElement = titleContent && (
    <HeadingLevel
      className="hbs-text-callout__header"
      {...editAttributes?.titleContent}
    >
      {titleContent}
    </HeadingLevel>
  );

  return items.length > 1 ? (
    <TeaseCarousel
      description={headerElement}
      itemsPerPage={1}
      align={align}
      className="hbs-text-callout"
    >
      {items.map((item, i) => (
        <TeaseCarouselItem key={i}>
          {item.content && (
            <div
              className="hbs-text-callout-carousel__item"
              {...item.editAttributes?.content}
            >
              {item.content}
            </div>
          )}
        </TeaseCarouselItem>
      ))}
    </TeaseCarousel>
  ) : (
    <div className={wrapperClass}>
      {headerElement}
      <div className="hbs-text-callout-carousel__item">{items[0]?.content}</div>
    </div>
  );
}
